/**
 * https://developers.facebook.com/docs/meta-pixel/implementation/conversion-tracking/
 *
 * Created by Andrey Popov on 1/17/22.
 */

const FacebookPixelLogger = function () {
    this.config = {
        lifetime: "30 days"
    };
};

FacebookPixelLogger.prototype.trackEvent = function (name, params) {
    connector.platform.callNative("FacebookPixel.logEvent", { name, params });
};

FacebookPixelLogger.prototype.trackPurchase = function (product, purchase, params) {
    connector.platform.callNative("FacebookPixel.logPurchase", {
        currency: params.currency,
        value: params.value
    });
};

FacebookPixelLogger.prototype.trackAdRevenue = function (name, impressionCost, options) {
    options = options || {};

    if (name === "sticky") {
        name = "banner";
    }

    connector.platform.callNative("FacebookPixel.logAdRevenue", {
        value: impressionCost,
        currency: "USD",
        ad_format: name,
        ad_placement: options.placement
    });
};

FacebookPixelLogger.isApplicable = function () {
    return connector.platform.oneOf(connector.CLEVERAPPS);
};
